import request from "@/utils/request.js"

export function getList(parm){
    return request.get("/workplace",{
        params:parm
    })
}
export function getAll(parm={}){
	return request.get("/workplace/all",{
		params:parm
	})
}
export function addWP(parm){
    return request.post("/workplace",{
        data:parm
    })
}
export function updateWP(parm){
    return request.put("/workplace",{
        data:parm
    })
}

export function deleteWP(parm){
    return request.delete("/workplace",{
        params:parm
    })
}

export function WPauth(parm){
    return request.put("/workplace/auth",{
        data:parm
    })
}
export function getauthuser(parm){
    return request.get("/workplace/authuserlist",{
        params:parm
    })
}